export default __webpack_public_path__ + "static/media/bg-office.56f3f6a7.svg";